<template>
  <div>
    <div class="px-6 text-gray-800 dark:text-dark-text" v-html="formattedMessage" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useReviewPostPresenter } from '@/presentation/composables/reviewPost/useReviewPostPresenter'

export default defineComponent({
  components: {},
  props: {
    entryId: {
      type: String,
      required: true
    },
    entryType: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  setup(props, ctx) {
    const { isLightMode } = useConfigStatePresenter()
    const { getEntryDetail } = useReviewPostPresenter()

    const codeStyle = computed(() =>
      isLightMode()
        ? 'p-3 my-2 select-text border bg-gray-100 whitespace-pre-wrap border-gray-200 text-gray-900'
        : 'p-3 my-2 select-text border bg-dark-400 whitespace-pre-wrap border-dark-300 text-dark-text'
    )

    const formatCode = (match: string, lang: string, code: string) =>
      `<pre class="${codeStyle.value}" style="border-radius:0.5rem;">${escapeHTML(code)}</pre>`

    const escapeHTML = (str: string) =>
      str.replace(/[&<>"']/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[m] || m)

    const formatMessage = (text: string) =>
      text.replace(/```([\w+#]+)\n([\s\S]*?)\n```/g, formatCode).replace(/\n/g, '<br>')

    const formattedMessage = computed(() => {
      const detail = getEntryDetail(props.entryId)
      return formatMessage(detail.value.message)
    })

    return { formattedMessage }
  }
})
</script>

<style lang="postcss" scoped></style>
